import React, { useEffect, useState } from "react";
import { Row, Col, ListGroup, Card } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
// import { useMediaQuery } from 'react-responsive';
import { useStoreState, useStoreDispatch, APP_STORE_ACTION } from '../../../../common/storeContext';
import { useMiddletier } from "../../../../common/middletier";
import Loading from '../../../../components/Loading';
import { useNavigate } from "react-router-dom";


const UserInfo = () => {
    const appState = useStoreState()
    const { query } = useMiddletier()
    const [userInfo, setUserInfo] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const appDispatch = useStoreDispatch()
    const navigate = useNavigate();
    const { t } = useTranslation();


    // const isDesktopOrLaptop = useMediaQuery({
    //     query: '(min-width: 992px)'
    // })


    useEffect(() => {
        if (appState?.user?.username) {
            const method = 'getAffiliate'
            query({
                method,
                params: [
                    { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { username: appState.user.username } } }
                ],
                attributes: ['email', 'phone_number', ['_user', ['name']], 'username']

            }).then(({ data }) => {
                setUserInfo(data[method]?.[0])
            }).catch((error) => {
                console.log('error: ', error)
                if (error?.networkError?.statusCode === 401) {
                    appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
                } else {
                    appDispatch({
                        type: APP_STORE_ACTION.SHOW_ALERT,
                        payload: { description: error.message.toString(), typeAlert: 'error' }
                    });
                }
            })
        }


    }, [appState?.user?.username, query, appDispatch, navigate]);





    return (
        <>
            <div className="userInfo_body">
                <div className="wallet_container_wrap">
                    <Row>
                        <Col lg={7}>
                            <Card className="myAccount_userInfo_profile">
                                <div className="subTitle">{t('personal_information')}</div>
                                <ListGroup className="list-group-flush">
                                    <ListGroup.Item className="">
                                        <label>{t('username')}</label>
                                        <p>{userInfo?.username}</p>
                                    </ListGroup.Item>

                                    <ListGroup.Item className="">
                                        <label>{t('email')}</label>
                                        <p>{userInfo?.email}</p>
                                    </ListGroup.Item>

                                </ListGroup>
                            </Card>
                            <Card className="myAccount_userInfo_profile">
                                <div className="subTitle">{t('contact_information')}</div>
                                <ListGroup className="list-group-flush">
                                    <ListGroup.Item>
                                        <label>{t('phone_number')}</label>
                                        <p>{userInfo?.phone_number && (userInfo?.phone_number.slice(-4).padStart(userInfo?.phone_number.length, '*'))}</p>
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <label>{t('full_name')}</label>
                                        <p>{userInfo?._user?.name}</p>
                                    </ListGroup.Item>
                                    {/* <ListGroup.Item>
                                        <label>{t('currency')}</label>
                                        <p>{userInfo?.currency}</p>
                                    </ListGroup.Item> */}
                                </ListGroup>
                            </Card>
                        </Col>

                    </Row>


                </div>
            </div>
            {isLoading && (<Loading />)}
        </>
    );

};






export default UserInfo;
